import { useState, useEffect } from "react";
import Layout from "../../components/Layout";
import queryString from "query-string";
import ReturnToButton from "../../components/ReturnToButton";
import TextField from "../../audi-ui-components/TextField";
import Checkbox from "../../audi-ui-components/Checkbox";
import CheckboxGroup from "../../components/CheckboxGroupField";
import Select from "../../audi-ui-components/Select";
import Button from "../../audi-ui-components/Button";
import Disclaimer from "../../components/Disclaimer";
import Spinner from "../../audi-ui-components/Spinner";
import { Formik, Form } from "formik";
import { validate, defaultSchema } from "../../functions/validation";
import { gtmPageview, gtmPush } from "../../functions/gtm";
import API from "../../functions/api";
import _find from "lodash/find";
import {
  UI_NONE,
  DEFAULT_THEME,
  LABEL_OPTIN,
  COUNTRIES,
  COUNTRIES_TOP,
} from "../../constants";

const F1RyiForm = ({ match, location, history }) => {
  //
  const variantNames = ["RS 5 Sedan", "RS 5 Avant"];

  const initVals = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    mobilePhone: "",
    postCode: "",
    optIn: false,
    optOut: false,
    dealerContact: false,
    preferredContactMethod: "Email",
    planningToBuyCar: "",
    findDealerBy: "postcode",
    country: "",
  };

  const query = queryString.parse(location.search);
  const theme = query.theme || DEFAULT_THEME;
  const [submittedData, setSubmittedData] = useState(null);
  const [gqlVariants, setGqlVariants] = useState([]);
  const [isLoadingVariants, setIsLoadingVariants] = useState(true);

  const validateForm = (values) => {
    var schema = {
      firstName: defaultSchema.firstName,
      lastName: defaultSchema.lastName,
      emailAddress: defaultSchema.emailAddress,
      postCode: defaultSchema.postCode,
      modelVariantNames: {
        presence: {
          message: "Please make a selection",
          allowEmpty: false
      }},
      optIn: {
        truthy: {message: "This field is required"}
      }
    };
    // if (values.dealerContact) {
    //   schema.dealerName = defaultSchema.dealerName;
    //   schema.preferredContactMethod = defaultSchema.preferredContactMethod;
    //   schema.planningToBuyCar = defaultSchema.planningToBuyCar;
    //   if (values.preferredContactMethod && (values.preferredContactMethod.indexOf("Phone") > -1 || values.preferredContactMethod.indexOf("SMS") > -1)) {
    //     schema.mobilePhone = defaultSchema.mobilePhone;
    //   }
    // }
    var v = validate(values, schema, {format: "firstError", fullMessages: false});
    return v;
  }

  const submitForm = (values, formikProps) => {
    let payload = {...values};
    payload.description = "F1 Event";
    payload.optOut = false;
    payload.modelVariants = [];
    let namesList = values.modelVariantNames.split("|");
    for (let i=0; i<namesList.length; i++) {
      let gqlV = _find(gqlVariants, {name: namesList[i]});
      if (gqlV?.name) {
        payload.modelVariants.push(gqlV);
      }
    }
    if (payload.country) {
      let countryOpt = _find(COUNTRIES, {value: payload.country});
      payload.countryName = countryOpt?.label;
    }
    if (process.env.RAZZLE_APP_ENV !== "local" || payload.submitToBackend) {
      gtmPush("form", "formSubmit", "f1-ryi", payload);
      return API({
        method: "POST",
        url: `${process.env.RAZZLE_API_HOST}/1/form`,
        data: {formName: 'registerYourInterest', payload, variation: 1}
      }).then((result) => {
        window.scrollTo(0,0);
        gtmPush("form", "formSubmitSuccess", "f1-ryi", payload);
        setSubmittedData(payload);
        formikProps.setSubmitting(false);
        // gtmPageview(`${PATH_UPCOMINGMODELS}${PATH_THANKS}`);
      }).catch((error) => {
        // console.error(error);
        formikProps.setSubmitting(false);
        gtmPush("form", "formSubmitError", "f1-ryi", payload);
        let msg = "An error has occured";
        let errors = {};
        if (error.response?.data) {
          if (error.response.data.modelState) {
            for (let key in error.response.data.modelState) {
              if (!Object.hasOwnProperty(key)) {
                errors[key] = error.response.data.modelState[key][0];
              }
            }
            msg = "There was a problem with the information you submitted, check the fields above for errors.";
          } else {
            msg = error.response.data.message || "An error has occured";
          }
        }
        errors.submit = msg;
        formikProps.setErrors(errors);
        scrollToError();
      });
    } else {
      // fake submit for frontend testing
      console.log(payload);
      setSubmittedData(payload);
      formikProps.setSubmitting(false);
    }
  };

  const scrollToError = () => {
    setTimeout(() => {
      let el = document.querySelector(".is-invalid");
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center"});
      }
    }, 1000);
  };

  useEffect(() => {
    gtmPageview(match.url);
    API.post(`${process.env.RAZZLE_GQLAPI}`, {
      query: /* GraphQL */`query ($skip: Int, $take: Int, $sort: VariantDtoSortInput!, $filter: VariantDtoFilterInput) {
        variantList(skip: $skip, take: $take, order: [ $sort ], where: $filter) {
          items {
            variantId
            name
            heroImage
            ryiStatus
            engineType
            isEtron: electric
            modelId
            activeBrochureName
          }
          totalCount
        }
      }`,
      variables: {
        skip: 0,
        take: 50,
        sort: {name: "ASC"},
        filter: {status: {eq: true}, ryi: {eq: true}, name: { in: variantNames }}
      }
    }).then((result) => {
      if (result.data?.data?.variantList?.items) {
        let list = result.data.data.variantList.items;
        setGqlVariants(list || []);
        // let vOpts = [];
        // for (let i=0; i<variants.length; i++) {
        //   let gqlV = _find(result.list, {name: variants[i].name});
        //   if (gqlV?.name) {
        //     vOpts.push(variants[i]);
        //   }
        // }
        // setVariantOpts(vOpts);
      }
      setIsLoadingVariants(false);
    }).catch((error) => {
      // console.error(error);
      setIsLoadingVariants(false);
    });
  }, []);

  return (
    <Layout ui={UI_NONE} theme={theme}>
      <main className="audi-forms__page">
        <div className="pt-3 pt-medium-5">

          {submittedData?.modelVariants &&
            <div className="row justify-content-center">
              <div className="col-12 col-small-6 col-large-5 text-center pb-5">
                <p className="aui-font-extended mb-5">
                  Thank you for your interest. We look forward to sharing updates on the {submittedData?.modelVariants?.length === 1 ? <b>{submittedData.modelVariants[0].name}</b> : <>vehicles you selected</>} as they become available.
                </p>
                <div className="pb-5"><ReturnToButton query={query} /></div>
              </div>
            </div>
          }

          {!submittedData?.modelVariants && (
            <Formik validate={validateForm} onSubmit={submitForm} initialValues={initVals}>
              {({values, errors, touched, setValues, setFieldValue, setFieldTouched, isSubmitting, submitCount}) => (
                <Form>
                  {isSubmitting && <div className="spinner-wrapper sticky"><Spinner isContinuous /></div>}
                  <h4 className="aui-headline-4 mb-2">Keep me informed</h4>
                  <p className="mb-3 mb-small-5">Enter your details so we can keep you updated with the latest information on your selected model(s).</p>
                  <div>
                    <CheckboxGroup name="modelVariantNames"
                      label="I am interested in:"
                      value={values.modelVariantNames}
                      options={variantNames.map((n) => ({value: n, label: n}))}
                      delimeter="|"
                      checkboxClassName="d-block mb-3 aui-font-extended"
                      onChange={(v) => { setFieldValue('modelVariantNames', v); }}
                      onBlur={() => { setFieldTouched('modelVariantNames'); }}
                      isInvalid={errors.modelVariantNames && (touched.modelVariantNames || submitCount > 0)}
                      invalidMessage={errors.modelVariantNames}
                      theme={theme === "dark" ? "light" : null}
                    />
                  </div>
                  <div className="row">
                    <div className="col-12 col-small-6">
                      <TextField name="firstName"
                          label="First name *"
                          value={values.firstName}
                          onChange={(v) => { setFieldValue('firstName', v); }}
                          isInvalid={errors.firstName && (touched.firstName || submitCount > 0)}
                          invalidMessage={errors.firstName}
                          onBlur={() => { setFieldTouched('firstName'); }}
                          className="form-field"
                          theme={theme === "dark" ? "light" : null}
                      />
                    </div>
                    <div className="col-12 col-small-6">
                      <TextField name="lastName"
                          label="Last name *"
                          value={values.lastName}
                          onChange={(v) => { setFieldValue('lastName', v); }}
                          isInvalid={errors.lastName && (touched.lastName || submitCount > 0)}
                          invalidMessage={errors.lastName}
                          onBlur={() => { setFieldTouched('lastName'); }}
                          className="form-field"
                          theme={theme === "dark" ? "light" : null}
                      />
                    </div>
                  </div>
                  <TextField name="emailAddress"
                    label="Email address*"
                    value={values.emailAddress}
                    onChange={(v) => { setFieldValue('emailAddress', v.trim()); }}
                    isInvalid={errors.emailAddress && (touched.emailAddress || submitCount > 0)}
                    invalidMessage={errors.emailAddress}
                    onBlur={() => { setFieldTouched('emailAddress'); }}
                    className="form-field"
                    theme={theme === "dark" ? "light" : null}
                  />
                  <Select name="country"
                    label="Country *"
                    value={values.country || ""}
                    options={[...COUNTRIES_TOP, {label: "──────────", value: "_", disabled: true}, ...COUNTRIES.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))]}
                    onChange={(v) => {
                      setFieldValue("country", v);
                      if (v === "AU") {
                        setFieldValue("postCode", "");
                      } else {
                        setFieldValue("postCode", "9998");
                      }
                    }}
                    isInvalid={errors.country && (touched.country || submitCount > 0)}
                    onBlur={() => { setFieldTouched('country'); }}
                    className="form-field"
                    theme={theme === "dark" ? "light" : null}
                  />
                  {values.country === "AU" && <TextField name="postCode"
                    label="Postcode *"
                    value={values.postCode}
                    onChange={(v) => {
                      let _v = v.trim();
                      setFieldValue('postCode', _v);
                      if (!values.dealerPostcode && /^\d{4}$/.test(_v)) { setFieldValue('dealerPostcode', _v, false); }
                    }}
                    isInvalid={errors.postCode && (touched.postCode || submitCount > 0)}
                    invalidMessage={errors.postCode}
                    onBlur={() => {
                      setFieldTouched('postCode');
                    }}
                    className="form-field"
                    theme={theme === "dark" ? "light" : null}
                  />}
                  <div className="pt-4">
                    <Checkbox name="optIn"
                      label={<>{LABEL_OPTIN}*</>}
                      checked={!!values.optIn}
                      value=""
                      onChange={(v,e) => { setFieldValue('optIn', e.target.checked); }}
                      onBlur={() => { setFieldTouched('optIn'); }}
                      isInvalid={errors.optIn && (touched.optIn || submitCount > 0)}
                      invalidMessage={errors.optIn}
                      className="form-field"
                      theme={theme === "dark" ? "light" : null}
                    />
                  </div>
                  {process.env.RAZZLE_APP_ENV === 'local' && <div className="form-field dev-only">
                    <Checkbox
                      name="submitToBackend"
                      label="Submit to backend"
                      checked={!!values.submitToBackend}
                      value=""
                      onChange={(v,e) => { setFieldValue('submitToBackend', e.target.checked); }}
                    />
                  </div>}
                  <div className="form-field submit">
                    {errors.modelVariants && submitCount > 0 && <p className="aui-color-text-red submit-error mb-1">{errors.modelVariants}</p>}
                    {errors.submit && <p className="aui-color-text-red submit-error mb-2">{errors.submit}</p>}
                    <Button type="submit" variant="primary" theme={theme === "dark" ? "light" : null} isStretched onClick={scrollToError}>
                      Submit
                    </Button>
                  </div>
                  <p className="mb-3 aui-small">All fields marked with * are mandatory.</p>
                  <Disclaimer>
                    <p>
                      Audi, a division of Volkswagen Group Australia Pty Ltd, will collect and use your personal information for the following purposes: customer and prospective &mdash; customer care, advertising and marketing (including personalisation and segmentation), lead reporting and management, and the provision, administration and improvement of our products, services and customer engagement programs. Where relevant, we may also process your information to respond to enquiries and complaints, manage events and test &mdash; drive requests, and undertake analytics and reporting to improve customer experience.
                    </p>
                    <p>
                      We may disclose your information to Audi AG, other Audi importers (including the Audi importer in the country you selected above), authorised dealers, and trusted service providers who support the operation of our business and services.
                    </p>
                    <p>
                      We may also transfer your information to recipients located outside Australia, including jurisdictions that may not offer the same level of data protection as Australia or the EU/EEA. Where your information is transferred internationally, we implement appropriate safeguards and take reasonable steps to ensure overseas recipients handle your personal information in accordance with applicable privacy requirements and local regulations.
                    </p>
                    <p>
                      We process your information in accordance with the Privacy Act 1988 (Cth) and, where applicable, the GDPR and any other relevant local privacy laws.
                    </p>
                    <p>
                      We only share your information with third parties where this is necessary to provide our services, fulfil your request, or as required by law or enforceable regulatory or judicial order.
                    </p>
                    <p>
                      If you consent, Audi AG, other Audi importers (including the Audi importer in the country you selected above), authorised dealers, and trusted service providers may also use your personal information to send you communications concerning products, offers, news and events. Please note that Audi and Audi Dealers are separate organisations, and that Dealers will handle your information in accordance with their own privacy policies.
                    </p>
                    <p>
                      For more details about how we handle your personal information, your rights, and how to contact us, please refer to our <a href="https://www.audi.com.au/en/privacy-policy/" className="aui-textlink" target="_blank" rel="noopener noreferrer">Privacy Policy</a> or contact our Privacy Officer at: <a href="mailto:privacy@volkswagen.com.au" className="aui-textlink">privacy@volkswagen.com.au</a>.
                    </p>
                  </Disclaimer>
                </Form>
              )}
            </Formik>
          )}
        </div>
      </main>
    </Layout>
  );
};

export default F1RyiForm;
